import {isCordova} from "./isCordova";

const getFromClipboard = async () => {
	if (isCordova()) {
		return new Promise((resolve, reject) => {
			window.cordova.plugins.clipboard.paste((text) => {
				resolve(text);
			}, (error) => {
				reject(error);
			});
		});
	} else {
		const text = await navigator.clipboard.readText();
		return text;
	}

};
export default getFromClipboard;